const currencies = [
  {
    value: 'USD',
    symbol: '$'
  },
  {
    value: 'EUR',
    symbol: '€'
  },
  {
    value: 'GBP',
    symbol: '£'
  },
  {
    value: 'JPY',
    symbol: '¥',
    zeroDecimal: true
  },
  {
    value: 'SEK',
    symbol: 'kr',
    suffix: true
  },
  {
    value: 'PLN',
    symbol: 'zł',
    suffix: true
  },
  {
    value: 'ZAR',
    symbol: 'R'
  },
  {
    value: 'MKD',
    symbol: 'ден',
    suffix: true
  }
];

function findCurrency(currencyCode) {
  return currencies.find(
    (c) => c.value.toLowerCase() === (currencyCode || '').toLowerCase()
  );
}

export function getCurrencySign(currencyCode) {
  return findCurrency(currencyCode)?.symbol || '';
}

export function formatCurrencyAmount(amount, currency) {
  if (amount == null) return '';
  const found = findCurrency(currency);
  if (!found) return String(amount);
  const decimals = found.zeroDecimal ? 0 : 2;
  const formatted = Number(amount).toFixed(decimals);
  return found.suffix ? `${formatted} ${found.symbol}` : `${found.symbol}${formatted}`;
}

export default currencies;
